import { defineMessages } from 'utils/intl';

export default defineMessages({
  configure: '{productName} - Konfiguruj i kup',
  video: '{productName} - Film',
  traits: '{productName} - Charakterystyka',
  variants: '{productName} - Warianty',
  articles: '{productName} - Artykuły',
  rating: '{productName} - Ocena',
  documentation: '{productName} - Dokumentacja',
  availableOptions: '{productName} - Dostępne opcje',
  gallery: '{productName} - Galeria',
});
